import Quill from "quill";
import { Mention, MentionBlot } from "quill-mention";
import "quill-mention/dist/quill.mention.css";
import "quill/dist/quill.snow.css";

const Parchment = Quill.import("parchment");

const DiffHighlightClass = new Parchment.Attributor(
  "diffHighlight",
  "data-diff",
  {
    scope: Parchment.Scope.INLINE_ATTRIBUTE,
  },
);

Quill.register(DiffHighlightClass, true);
Quill.register({ "blots/mention": MentionBlot, "modules/mention": Mention });

export default Quill;
